import { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AdminAddStudentSessionException() {
  const [values, setValues] = useState(null);
  const { courseID, sessionID, examID } = useParams();
  const navigate = useNavigate();

  function reducer(state, action) {
    switch (action.type) {
      case "setErrors": {
        return {
          ...state,
          errors: action.payload,
        };
      }

      case "setSubmitAddStudentSessionException": {
        return {
          ...state,
          submitAddStudentSessionException: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddStudentSessionException: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  let api = process.env.REACT_APP_ADMIN_ADD_STUDENT_EXAM_EXCEPTIONS_API;
  //!--------- add edit session -------

  const [
    AddStudentSessionExceptionSuccess,
    AddStudentSessionExceptionErrors,
    AddStudentSessionExceptionLoading,
  ] = useAxios(
    api,
    "POST",
    state.submitAddStudentSessionException.flag,
    state.submitAddStudentSessionException.dependency,
    state.submitAddStudentSessionException.data,
    true
  );

  const [studentsSuccess, studentsErrors, studentsLoading] = useAxios(
    `${process.env.REACT_APP_ADMIN_VIEW_ALL_STUDENTS_COURSE_API}/${courseID}`,
    "GET",
    courseID,
    courseID
  );

  useEffect(() => {
    //!---add actions ----

    if (AddStudentSessionExceptionSuccess) {
      navigate(-1);
      reset();
    }
    //! make the dependency false again to listen to the next try to submit
  }, [AddStudentSessionExceptionSuccess]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onTouched", values });

  const onSubmit = (data) => {
    const finalData = {
      ...data,
      trial_exam_id: examID,
    };

    dispatch({
      type: "setSubmitAddStudentSessionException",
      payload: {
        flag: "AddEditCourse",
        dependency: !state.submitAddStudentSessionException.dependency,
        data: finalData,
      },
    });
  };

  return (
    <section className="flex h-auto w-full flex-col  items-center  dark:bg-dark dark:text-light">
      <HelmetTags title="Add Exception | Nash Academy"></HelmetTags>

      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          Please fill in the information to add exception
        </h2>

        <form
          encType="multipart/form-data"
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="md:max-w-3/4 flex  w-3/4  flex-col items-start justify-center gap-10 rounded-3xl bg-blue-200 p-16 shadow-lg shadow-blue-200/50"
        >
          {/** Name stage filed */}
          <div className="flex w-full items-start justify-between gap-16 md:flex-col md:gap-10 ">
            <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">Students</label>
              <select
                {...register("student_id", {
                  required: true,
                })}
              >
                <option value="">Select a student</option>
                {studentsSuccess &&
                  studentsSuccess?.data?.map((student) => (
                    <option key={student.student_id} value={student.student_id}>
                      {student.student_name}
                    </option>
                  ))}
              </select>
              {errors.student_id && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.student_id.type === "required" &&
                    "Please fill out this field"}
                </p>
              )}
              {
                //!-------server errors -----

                AddStudentSessionExceptionErrors &&
                  AddStudentSessionExceptionErrors?.response?.data?.errors
                    ?.student_id && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {
                        AddStudentSessionExceptionErrors?.response?.data?.errors
                          ?.student_id[0]
                      }
                    </p>
                  )
              }
            </div>
          </div>

          {/** submit */}

          <button
            disabled={
              !isValid ||
              (AddStudentSessionExceptionLoading &&
                state.submitAddStudentSessionException.flag)
            }
            className=" submit mt-6 w-full "
            type="submit"
          >
            {AddStudentSessionExceptionLoading &&
            state.submitAddStudentSessionException.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p> Add Exception</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default AdminAddStudentSessionException;
